import { IconProps } from './interfaces';

export const IconDropDown = ({ className }: IconProps) => {
    return (
        <svg width="21" height="20" viewBox="0 0 21 20" xmlns="http://www.w3.org/2000/svg" className={className}>
            <path d="M3.24394 6.91219C3.5693 6.58667 4.09694 6.58655 4.42245 6.91191L10.4996 12.9862L16.5768 6.91191C16.9023 6.58655 17.4299 6.58667 17.7553 6.91219C18.0806 7.2377 18.0805 7.76534 17.755 8.0907L11.0887 14.7538C10.7633 15.0791 10.2359 15.0791 9.91049 14.7538L3.24422 8.0907C2.9187 7.76534 2.91858 7.2377 3.24394 6.91219Z" />
        </svg>
    );
};
